import '../../../../assets/css/bills.css'
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import Checkbox from '@mui/material/Checkbox';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import Pagination from "react-js-pagination";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Input from "@mui/material/Input";
import { makeStyles } from '@mui/styles';

import { getAll_purchaseService_orders_bills, validate_request_order_bill_byPurchaseService } from '../../../../services/purchase_service';

import State_details from '../state_details/state_details';
import Loading_animation_view from '../../../loading_animation_view/loading_animation_view';
import { download_bills_docs, notify_finance_service } from '../../../../services/for_allServices';
import Set_new_bill from '../set_new_bill/set_new_bill';
import swal from 'sweetalert';
import Contract_details from '../../contracts_list/contract_details/contract_details';
import { delete_bill_from_db, upload_bill_docs } from '../../../../services/supplier_service';
import Set_refuse_reason from '../set_refuse_reason/set_refuse_reason';


const useStyles = makeStyles((theme) => ({
  button: { margin: 8, },
  root: {
    '& > *': {
      margin: 8,
    },
    width: '100%',
  },
  input: {
    display: 'none',
  },
  container: {
    maxHeight: 440,
  },
  select: {
    "&:focus": {
      backgroundColor: "white"
    }
  },
  selectInput: {
    "&:hover:not($disabled):not($focused):not($error):before": {
      borderBottomWidth: 0
    },
    "&:after": {
      borderBottomWidth: 0
    }
  },
  disabled: {},
  focused: {},
  error: {}
}));


function setState(bill_state, financeService_accord, purchaseService_accord, businessService_accord) {
  return (
    <>
      <Tooltip title="" placement="bottom" >
        <span style={{ marginLeft: '2%' }}>
          {
            financeService_accord === "0" || purchaseService_accord === "0" || businessService_accord === "0"
              ? <Button className="status_deny" >{"refusée"}</Button>
              : bill_state === "comptabilisée"
                ? <Button className="status_success" >{bill_state}</Button>
                : bill_state === "à valider" && (purchaseService_accord === null || businessService_accord === null)
                  ? <Button className="status_success" >{bill_state}</Button>
                  : bill_state === "mis en règlement"
                    ? <Button className="status_success" >{bill_state}</Button>
                    : bill_state === "réglée" || bill_state === "validée"
                      ? <Button className="status_success" >{bill_state}</Button>
                      : bill_state === "archivée"
                        ? <Button className="status_success" >{bill_state}</Button>
                        : <Button className="status_waiting" >{"en cours"}</Button>
          }
        </span>
      </Tooltip>
    </>
  );
}

function verify_if_able_to_seeDetails(bill) {
  if (bill.bill_state === "à valider" || bill.bill_state === "refusée") return true;
  return false;
}

function verify_if_able_update(bills, all = false) {
  if (bills.length === 0 && all === true) return true;
  var able = false;
  bills.map((bill) => {
    if (bill.bill_state === null || bill.financeService_accord === "0" || bill.purchaseService_accord === "0" || bill.businessService_accord === "0") able = true;
  })
  return able;
}

function numberWithSpaces(x) {
  if (x) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  else return x;
}

function verify_if_able_to_validate(bill_state) {
  if (bill_state == null || bill_state === "refusée") return true;
  return false;
}

function verify_if_able_to_refuse(bill_state) {
  if (bill_state == null || bill_state === "refusée") return true;
  return false;
}


function verify_if_able_to_archive(bill_state) {
  if (bill_state === "réglée") return true;
  return false;
}


function verify_if_all_bills_areChecked(array_selected_bills, id) {
  let checked = true;
  array_selected_bills[id].map((selected) => {
    if (selected === null) checked = false;
  });
  return checked;
}

function check_if_bills_selected(array_selected_bills) {
  let selected = 0;
  array_selected_bills.map((bill_selected) => {
    if (bill_selected !== null) selected++;
  });
  if (selected >= 2) return true;
  else return false;
}


function verify_if_able_to_validate_billsSelected(array_selected_bills) {
  var able = false;
  array_selected_bills.map((bill_selected) => {
    if (bill_selected !== null) {
      if ((bill_selected === "null" || bill_selected === "refusée")) able = true;
    }
  });
  return able;
}

function verify_if_able_to_refuse_billsSelected(array_selected_bills) {
  var able = false;
  array_selected_bills.map((bill_selected, id) => {
    if (bill_selected !== null) {
      if ((bill_selected === "null" || bill_selected === "refusée")) able = true;
    }
  });
  return able;
}



function Bill_column({ bill, id, id2, delete_bill_from_the_list, array_selected_bills, setArray_selected_bills, setAction_on_bill }) {

  const classes = useStyles();
  const selectInputClasses = {
    root: classes.selectInput,
    disabled: classes.disabled,
    focused: classes.focused,
    error: classes.error
  };

  const [waiting, setWaiting] = useState(false);
  const [view_state_details, setview_state_details] = useState(null);

  function check_bill(checked, bill_state, array_selected_bills, id, id2) {
    let tmp_array = [...array_selected_bills];
    if (checked === false) tmp_array[id][id2] = null;
    else tmp_array[id][id2] = bill_state == null ? "null" : bill_state;
    setArray_selected_bills(tmp_array);
  }

  function upload__billDocs(event, request_code, bill_number, choice) {
    console.log("bill", bill, bill_number);
    setWaiting(true);
    let formData = new FormData();
    formData.append(choice, event.target.files[0]);
    formData.append('request_code', request_code);
    formData.append('bill_number', bill_number);
    upload_bill_docs(formData).then((response) => {
      //console.log(response.data);
      setWaiting(false);
      swal("Le document a été modifié avec succès !", {
        icon: "success",
      });
    }).catch((error) => {
      //console.log(error.response);
      setWaiting(false);
    });
  }

  function download_billDocs(request_code, bill_number, choice) {
    const formData = new FormData();
    formData.append('request_code', request_code);
    formData.append('bill_number', bill_number);
    formData.append('choice', choice);
    download_bills_docs(formData).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      let file_extension = '';
      const disposition = response.headers['content-disposition'];
      if (disposition && disposition.includes('filename')) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          file_extension = matches[1].replace(/['"]/g, '').split(".")[1];
        }
      }
      fileLink.setAttribute('download', request_code.split(' - ')[0] + "_" + request_code.split(' - ')[1] + "_" + choice + "_" + bill_number + "." + file_extension);
      document.body.appendChild(fileLink);
      fileLink.click();
    }).catch(err => {
      //console.log(err,err.response);
    });
  }

  function delete_bill(market_id, bill_id, id) {
    swal({
      title: "Êtes-vous sûr ?",
      text: "!!!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (isConfirm) => {
      if (isConfirm) {
        setWaiting(true);
        let formData = new FormData();
        formData.append("bill_id", bill_id);
        await delete_bill_from_db(formData).then((response) => {
          console.log("message", response.data);
          setWaiting(false);
          swal("Supprimée !", "La facture a été supprimée avec succès.", "success");
          delete_bill_from_the_list(market_id, id);
        }).catch((error) => {
          console.error("Erreur lors de la suppression :", error.response);
        })
        setWaiting(false);
      }
    });
  }


  return (
    <div className='bill_container'>
      <div className='bill_infos_container'>
        <div className='bill_infos'>
          <Tooltip title="Choisir la facture" placement="bottom">
            <span style={{ marginRight: '7px' }}>
              <Checkbox className="my_icon" color="default" checked={array_selected_bills[id][id2] !== null ? true : false}
                onClick={(e) => check_bill(e.target.checked, bill.bill_state, array_selected_bills, id, id2)} />
            </span>
          </Tooltip>
          <span className='download_bill_button' onClick={() => download_billDocs(bill.request_code, bill.bill_number, "bill_content")} >
            <Fab size="small" color="default" >
              <DownloadIcon className="my_icon" />
            </Fab>
          </span>
          <div className='bill_name'>
            {bill.bill_number_value ?? "Facture N°" + bill.bill_number}
            <Tooltip title="Supprimer">
              <DeleteForeverIcon className={verify_if_able_update([bill]) ? "" : "disabled_button"} style={{ color: "#f33640f3", cursor: "pointer" }} onClick={() => delete_bill(id, bill.id, id2)} />
            </Tooltip>
          </div>
        </div>
        <div className='bill_amount'>
          {
            bill.amount_without_tax !== null
              ? <>{bill.amount_without_tax + " MAD"}</>
              : <span style={{ opacity: ".8" }} >non défini</span>
          }
        </div>
        <div className='bill_treatedDate'>
          {
            bill.expiration_date !== null
              ? (new Date(bill.expiration_date)).toLocaleString().split(/[,| ]/)[0]
              : <span style={{ opacity: ".8" }} >non défini</span>
          }
        </div>
        <div className='bill_treatedDate'>
          {(new Date(bill.limit_date)).toLocaleString().split(/[,| ]/)[0]}
        </div>
        <div className='select_container' >
          <FormControl variant="standard" style={{ width: "125px", marginLeft: "4px", marginRight: "8px" }} >
            <Select required value={"null"} className={array_selected_bills[id][id2] && !check_if_bills_selected(array_selected_bills[id]) ? "" : "disabled_button"}
              onChange={e => {
                setAction_on_bill(e.target.value, bill.request_code, bill.bill_number, id);
              }}
              input={<Input classes={selectInputClasses} />}
              inputProps={{ classes: { select: classes.select } }}>
              <MenuItem value={"null"} disabled>Action</MenuItem>
              <MenuItem value={"validate"} disabled={!verify_if_able_to_validate(bill.bill_state)}>Valider</MenuItem>
              <MenuItem value={"refuse"} disabled={!verify_if_able_to_refuse(bill.bill_state)}>Refuser</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className='bill_state_container'>
          <div className='bill_state'>{setState(bill.bill_state, bill.financeService_accord, bill.purchaseService_accord, bill.businessService_accord)}
            {
              verify_if_able_to_seeDetails(bill)
                ? <div className="refuse_raison_button"
                  onClick={() => setview_state_details(
                    [
                      [bill.financeService_refuse_reason, bill.purchaseService_refuse_reason, bill.businessService_refuse_reason],
                      [bill.financeService_accord, bill.purchaseService_accord, bill.businessService_accord]
                    ]
                  )}>
                  Details
                </div>
                : <div></div>
            }
          </div>

        </div>
      </div>

      <div className='bill_compDocs'>
        <div className='bill_compDoc'>
          <label htmlFor={"compDoc_reception" + id + "_" + id2} className={verify_if_able_update([bill]) ? "" : "disabled_button"}>
            <Fab size="small" color="default" component="span" >
              <CloudUploadIcon className="my_icon" />
            </Fab>
            <input accept="application/*" style={{ display: "none" }} name={"compDoc_reception" + id + "_" + id2} id={"compDoc_reception" + id + "_" + id2} multiple type="file" onChange={(e) => upload__billDocs(e, bill.request_code, bill.bill_number, "reception_pv")} />
          </label>
          <span style={{ marginRight: '7px' }} >
            <Fab size="small" color="default" className={!bill.reception_pv ? "disabled_button" : ""} onClick={() => download_billDocs(bill.request_code, bill.bill_number, "reception_pv")} >
              <DownloadIcon className="my_icon" />
            </Fab>
          </span>
          <span className='docs_name'>PV de réception</span>
        </div>
        <div className='bill_compDoc'>
          <label htmlFor={"compDoc_delivery" + id + "_" + id2} className={verify_if_able_update([bill]) ? "" : "disabled_button"}>
            <Fab size="small" color="default" component="span" >
              <CloudUploadIcon className="my_icon" />
            </Fab>
            <input accept="application/*" style={{ display: "none" }} name={"compDoc_delivery" + id + "_" + id2} id={"compDoc_delivery" + id + "_" + id2} multiple type="file" onChange={(e) => upload__billDocs(e, bill.request_code, bill.bill_number, "delivery_pv")} />
          </label>
          <span style={{ marginRight: '7px' }} >
            <Fab size="small" color="default" className={!bill.delivery_pv ? "disabled_button" : ""} onClick={() => download_billDocs(bill.request_code, bill.bill_number, "delivery_pv")}>
              <DownloadIcon className="my_icon" />
            </Fab>
          </span>
          <span className='docs_name'>PV de livraison</span>
        </div>
      </div>
      {
        view_state_details !== null
          ? <State_details view_state_details={view_state_details} setview_state_details={setview_state_details} />
          : <></>
      }
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={waiting}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

function Markets_list({ markets, setOrder_newBill, notify_financeService, check_All, array_selected_bills,
   setArray_selected_bills, delete_bill_from_the_list, setAction_on_bills_selected, setAction_on_bill }) {

  const classes = useStyles();
  const selectInputClasses = {
    root: classes.selectInput,
    disabled: classes.disabled,
    focused: classes.focused,
    error: classes.error
  };
  const [id_contract, setId_contract] = useState(null);

  function openContractDetails(id_contract) {
    setId_contract(id_contract);
  }

  return (
    <>
      {
        markets.map((market, id) => (
          <TableRow key={"market" + id}>
            <TableCell align="left">{market.request_code}
              <br />
              {market.off_catalogue !== null ?
                <Tooltip title="Visualiser les détails du contrat" placement="bottom">
                  <span style={{ marginRight: '6px' }}>
                    <VisibilityIcon
                      className="my_icon editIcon"
                      onClick={(e) => {
                        e.stopPropagation();
                        openContractDetails(market.order_id);
                      }}
                    />
                  </span>
                </Tooltip> : <></>}
            </TableCell>
            <TableCell align="left">{market.order_number}</TableCell>
            <TableCell align="left">{market.requester_fullName}</TableCell>
            <TableCell align="left">{market.supplier_fullName}</TableCell>
            <TableCell align="left">{numberWithSpaces(market.order_amount) + " MAD"}</TableCell>
            <TableCell align="left">
              <div>
                {
                  (market.bills).length !== 0
                    ? <>
                      <div className='bill_container_titles'>
                        <div className='bill_infos_container'>
                          <div className='bill_infos'>
                            <Tooltip title="Choisir tous les factures" placement="bottom">
                              <span style={{ marginRight: '7px' }}>
                                <Checkbox color="default" className="my_icon"
                                  checked={verify_if_all_bills_areChecked(array_selected_bills, id)}
                                  onClick={(e) => check_All(e.target.checked, market.bills, array_selected_bills, id)} />
                              </span>
                            </Tooltip>
                            <div className='bill_name'>Toutes les factures</div>
                          </div>
                          <div className='bill_amount'> Montant <br /> hors Tax</div>
                          <div className='bill_treatedDate'>Date <br /> d'échéance</div>
                          <div className='bill_treatedDate'>Date limite</div>
                          <div className='select_container' >
                            <Tooltip title="Traitement en masse" placement="left">
                              <span>
                                <FormControl variant="standard" style={{ width: "125px", marginLeft: "4px", marginRight: "8px" }} className={check_if_bills_selected(array_selected_bills[id]) ? "" : "disabled_button"} >
                                  <Select required value={"null"}
                                    onChange={e => {
                                      setAction_on_bills_selected(e.target.value, market.bills[0].request_code, market.bills, array_selected_bills, id);
                                    }}
                                    input={<Input classes={selectInputClasses} />}
                                    inputProps={{ classes: { select: classes.select } }}
                                  >
                                    <MenuItem value={"null"} disabled>Action</MenuItem>
                                    <MenuItem value={"validate"} disabled={!verify_if_able_to_validate_billsSelected(array_selected_bills[id])}>Valider</MenuItem>
                                    <MenuItem value={"refuse"} disabled={!verify_if_able_to_refuse_billsSelected(array_selected_bills[id])}>Refuser</MenuItem>
                                  </Select>
                                </FormControl>
                              </span>
                            </Tooltip>
                          </div>
                          <div className='bill_state'>Status</div>
                        </div>
                        <div className='bill_compDocs'>
                          <span className='docs_name'>Docs complémentaires</span>
                        </div>
                      </div>
                      {
                        market.bills.map((bill, id2) => (
                          <Bill_column bill={bill} id={id} id2={bill.bill_number - 1} key={"market_bill" + id + id2} delete_bill_from_the_list={delete_bill_from_the_list}
                            array_selected_bills={array_selected_bills} setArray_selected_bills={setArray_selected_bills} setAction_on_bill={setAction_on_bill} />
                        ))
                      }
                    </>
                    : <></>
                }

                <div className='add_bill_container'>
                  {
                    (market.bills).length == 0
                      ? <span>Aucune facture déposée</span>
                      : <span></span>
                  }
                  <div>
                    <Tooltip title="Déposer une facture" placement="bottom">
                      <span className={verify_if_able_update(market.bills, true) ? "add_button" : "add_button"} onClick={() => setOrder_newBill(market, id)}>
                        Déposer une facture
                      </span>
                    </Tooltip>
                    <Tooltip title="Notifier le service de finance" placement="bottom">
                      <span className={(market.bills).length != 0 ? "add_button" : "add_button disabled_button"} style={{ marginLeft: "10px" }} onClick={() => notify_financeService(market)}>
                        Notifier
                      </span>
                    </Tooltip>
                  </div>

                </div>
              </div>
            </TableCell>
          </TableRow>
        ))
      }
      {id_contract != null
        ? <Contract_details id_contract={id_contract} setId_contract={setId_contract} /> : <></>}
    </>
  );
}


function Orders_bills({ filter_bills_src, setUrl_updated, url_updated }) {

  let purchase_service = JSON.parse(localStorage.getItem('user-info'))
  let history = useHistory();

  const [markets, setMarkets] = useState(null);
  const [array_selected_bills, setArray_selected_bills] = useState(null);

  const [add_bill, setAdd_bill] = useState(null);
  const [chosenSubmission, setChosenSubmission] = useState(null);
  const [chosenRequest_code, setchosenRequest_code] = useState(null);
  const [chosenBills_numbers, setChosenBills_numbers] = useState(null);
  const [open_reason_modal, setOpen_reason_modal] = useState(null);

  const [search_value, setsearch_value] = useState("");
  const [search_filter, setsearch_filter] = useState('all');

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setdataPerPage] = useState(5);
  const [data_count, setdata_count] = useState(0);

  const [waiting, setWaiting] = useState(false);

  useEffect(() => {
    setArray_selected_bills(null);
    setMarkets(null);
    setdata_count(0);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var tmp_searchFilter = "all";
    var tmp_searchValue = null;
    async function load_data() {
      if (urlParams.get('filtre')) {
        tmp_searchFilter = urlParams.get('filtre');
      } if (urlParams.get('valeur')) {
        tmp_searchValue = urlParams.get('valeur');
      }

      await setsearch_filter(tmp_searchFilter);
      await setsearch_value(tmp_searchValue);

      let page = (urlParams.get('page') ? urlParams.get('page') : 1);
      await setCurrentPage(page)
      let formData = new FormData();
      formData.append("id_purchaseService", purchase_service.id);
      await getAll_purchaseService_orders_bills(formData, tmp_searchFilter, tmp_searchValue, page).then((response) => {
        setdata_count(response.data.total);

        let tmp_array = [];
        response.data.data.map((market) => {
          let bills_selection = [];
          for (let i = 0; i < market.bills.length; i++) {
            bills_selection.push(null);
          }
          tmp_array.push(bills_selection);
        });
        console.log("tmp_array", tmp_array);
        setArray_selected_bills(tmp_array);
        setMarkets(response.data.data);
        console.log("orders_bills$$->", response.data.data);

      }).catch(err => {
        //console.log(err,err.response);
      });

    }
    load_data();
  }, [url_updated]);


  function search() {
    let path = history.location.pathname;
    history.push(path + "?src=" + filter_bills_src + "&filtre=" + search_filter + "&valeur=" + search_value);
    setUrl_updated(search_value);
  }


  function set__filter(value) {
    if (value === "all") {
      setsearch_filter(value);
      let path = history.location.pathname;
      history.push(path + "?src=" + filter_bills_src + "&filtre=" + value);
      setUrl_updated(value);
    } else setsearch_filter(value);
  }


  function set_bills_src(value) {
    let path = history.location.pathname;
    history.push(path + "?src=" + value);
    setUrl_updated(value);
  }


  function check_All(checked, bills, array_selected_bills, id) {
    console.log(checked);
    let tmp_selected_list = [];
    let tmp_array = [...array_selected_bills];
    bills.map((bill) => {
      if (checked === false) tmp_array[id][bill.bill_number - 1] = null;
      else tmp_array[id][bill.bill_number - 1] = bill.bill_state == null ? "null" : bill.bill_state;
    });
    setArray_selected_bills(tmp_array);
  }


  function setAction_on_bill(action, request_code, bill_number, id) {
    console.log(action, request_code, bill_number, id);
    setChosenBills_numbers([bill_number]);
    setchosenRequest_code(request_code);
    let formData = new FormData();
    formData.append("bills_numbers", JSON.stringify([bill_number]));
    formData.append("request_code", request_code);
    if (action === "refuse") {
      setOpen_reason_modal(id);
    }
    if (action === "validate") {
      swal({
        title: "Etes-vous sûr ?",
        text: "!!!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            setWaiting(true);
            validate_request_order_bill_byPurchaseService(formData).then((response) => {
              let tmp_array = [...markets];
              tmp_array[id].bills = response.data;
              setMarkets(tmp_array);
              setWaiting(false);
            }).catch((error) => {
              //console.log(error.response);
              setWaiting(false);
            });
          }
        })
    }
    check_All(false, markets[id].bills, array_selected_bills, id);

  }

  function setAction_on_bills_selected(action, request_code, bills, array_selected_bills, id) {
    let bills_numbers = [];
    array_selected_bills[id].map((selected, id) => {
      if (selected !== null) bills_numbers.push(id + 1);
    })
    //console.log(bills_numbers);
    setChosenBills_numbers(bills_numbers);
    setchosenRequest_code(request_code);
    let formData = new FormData();
    formData.append("bills_numbers", JSON.stringify(bills_numbers));
    formData.append("request_code", request_code);
    if (action === "refuse") {
      setOpen_reason_modal(id);
    }
    if (action === "validate") {
      swal({
        title: "Etes-vous sûr ?",
        text: "!!!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            setWaiting(true);
            validate_request_order_bill_byPurchaseService(formData).then((response) => {
              let tmp_array = [...markets];
              tmp_array[id].bills = response.data;
              setMarkets(tmp_array);
              setWaiting(false);
            }).catch((error) => {
              //console.log(error.response);
              setWaiting(false);
            });
          }
        })
    }
    check_All(false, bills, array_selected_bills, id);

  }


  function notify_financeService(order_infos) {
    console.log(order_infos);
    setWaiting(true);
    let formData = new FormData();
    formData.append("request_code", order_infos.request_code);
    formData.append("order_id", order_infos.order_id);
    formData.append("id_supplier", order_infos.id_supplier);
    notify_finance_service(formData).then((response) => {
      //console.log(response.data);
      setWaiting(false);
      swal("Le service sera bientôt notifié !", {
        icon: "success",
      });
    }).catch((error) => {
      setWaiting(false);
      //console.log(error.response);
    })
  }


  function setOrder_newBill(order_infos, id_list) {
    setChosenSubmission(order_infos);
    setAdd_bill(id_list);
  }


  function submit_new_bills(newBills, id) {
    let tmp_array = [...markets];
    tmp_array[id].bills = newBills;
    setMarkets(tmp_array);
    let bills_selection = [];
    let tmp_array_selected_bills = [...array_selected_bills];
    for (let i = 0; i < newBills.length; i++) {
      bills_selection.push(null);
    }
    console.log(id, bills_selection);
    tmp_array_selected_bills[id] = bills_selection;
    setArray_selected_bills(tmp_array_selected_bills);
  }

  function delete_bill_from_the_list(market_id,bill_id){
    console.log(market_id);
    let tmp_array = [...markets];
    tmp_array[market_id].bills.splice(bill_id,1);
    setMarkets(tmp_array);
  }

  async function change_page(page) {
    await setCurrentPage(page);
    let path = history.location.pathname;
    let params = history.location.search;
    let search_params = params.split('&');
    let tmp_params = path;
    if (!params) history.push(path + "?page=" + page);
    else {
      for (let i in search_params) {
        if (search_params[i].includes("page=")) {
          if (i == 0) tmp_params = tmp_params + "?page=" + page;
          else tmp_params = tmp_params + "&page=" + page;
        } else {
          if (i == 0) tmp_params = tmp_params + search_params[i];
          else tmp_params = tmp_params + "&" + search_params[i];
        }
      }
      if (!tmp_params.includes("page=")) tmp_params = tmp_params + "&page=" + page;
      history.push(tmp_params);
    }
    await setUrl_updated(page);
  }

  return (
    <>
      {
        markets == null
          ? <Loading_animation_view />
          : <div className='purchase_bills_container'>
            {<div className='bills_src_header'>
              <FormControl variant="standard" className="header_form" >
                <InputLabel id="demo-simple-select-helper-label">Factures/paiement</InputLabel>
                <Select required value={filter_bills_src}
                  onChange={e => { set_bills_src(e.target.value) }} >
                  {/* <MenuItem value={"marchés"} >{"Marchés"}</MenuItem> */}
                  <MenuItem value={"commandes"} >{"Bons de commande"}</MenuItem>
                  <MenuItem value={"contract"} >{"Contrats"}</MenuItem>

                </Select>
              </FormControl>
            </div>}
            <div className='three_forms_header_container'>
              <div className='page_title'>Bons de commande</div>
              <div className='search_filter_container'>
                <FormControl variant='standard' className="header_form" >
                  <InputLabel id="demo-simple-select-helper-label">Filtre</InputLabel>
                  <Select value={search_filter} onChange={(e) => { set__filter(e.target.value) }}>
                    <MenuItem value="all">Aucun</MenuItem>
                    <MenuItem value='demandeur'>Nom du demandeur</MenuItem>
                  </Select>
                </FormControl>

                <Grid container spacing={1} alignItems="flex-start" className={search_filter === "all" ? "search_bar disabled_button" : "search_bar"} >
                  <Grid item>
                    <SearchIcon onClick={search} className={search_value === "" ? "disabled_button my_icon" : "my_icon"} style={{ cursor: "pointer" }} />
                  </Grid>
                  <Grid>
                    <TextField variant='standard' label="Chercher" value={search_value} onChange={(e) => { setsearch_value(e.target.value) }} />
                  </Grid>
                </Grid>
              </div>
            </div>
            <div className="bills_table_container purchase_bills_table_container">
              <TableContainer className="bills_table">
                <Table aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Code de demande</TableCell>
                      <TableCell>Nm. commande</TableCell>
                      <TableCell>Demandeur</TableCell>
                      <TableCell>Fournisseur</TableCell>
                      <TableCell>Montant</TableCell>
                      <TableCell>Factures</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      markets.length !== 0
                        ? <Markets_list check_All={check_All} markets={markets} setOrder_newBill={setOrder_newBill} notify_financeService={notify_financeService}
                          array_selected_bills={array_selected_bills} setArray_selected_bills={setArray_selected_bills} delete_bill_from_the_list={delete_bill_from_the_list}
                          setAction_on_bills_selected={setAction_on_bills_selected} setAction_on_bill={setAction_on_bill} />
                        : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucune facture disponible</div>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            {
              markets.length !== 0
                ? <div className="pagination_container">
                  <Pagination
                    activePage={Number(currentPage)}
                    itemsCountPerPage={dataPerPage}
                    totalItemsCount={Number(data_count)}
                    pageRangeDisplayed={4}
                    onChange={change_page.bind(this)}
                  />
                </div>
                : <></>
            }
          </div>
      }
      {
        add_bill != null
          ? <Set_new_bill add_bill={add_bill} setAdd_bill={setAdd_bill} order_infos={chosenSubmission} submit_new_bills={submit_new_bills} />
          : <></>
      }
      {
        open_reason_modal !== null
          ? <Set_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal}
            request_code={chosenRequest_code} bills_numbers={chosenBills_numbers} markets={markets}
            setMarkets={setMarkets} />
          : <></>
      }
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={waiting}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default Orders_bills;
